module.exports = __webpack_public_path__ + "img/authenticationConfirm.2fc90216.png";